const dictionary = {
  pt_BR: {
    messages: {
      _default: (e) => `O valor do campo não é válido.`,
      after: (e, n) => `O campo deve estar depois do campo ${n[0]}.`,
      alpha_dash: (e) => `O campo deve conter letras, números e traços.`,
      alpha_num: (e) => `O campo deve conter somente letras e números.`,
      alpha_spaces: (e) => `O campo só pode conter caracteres alfabéticos e espaços.`,
      alpha: (e) => `O campo deve conter somente letras.`,
      before: (e, n) => `O campo deve estar antes do campo ${n[0]}.`,
      between: (e, n) => `O campo deve estar entre ${n[0]} e ${n[1]}.`,
      confirmed: (e, n) => `Os campos ${e} e ${n[0]} devem ser iguais.`,
      credit_card: (e) => `O campo é inválido.`,
      date_between: (e, n) => `O campo deve estar entre ${n[0]} e ${n[1]}.`,
      date_format: (e, n) => `O campo deve estar no formato dd/mm/aaaa.`,
      digits: (e, n) => `O campo deve ser numérico e ter exatamente ${n[0]} dígitos.`,
      dimensions: (e, n) => `O campo deve ter ${n[0]} pixels de largura por ${n[1]} pixels de altura.`,
      email: (e) => `O campo deve ser um email válido.`,
      ext: (e) => `O campo deve ser um arquivo válido.`,
      image: (e) => `O campo deve ser uma imagem.`,
      in: (e) => `O campo deve ter um valor válido.`,
      integer: (e) => `O campo deve ser um número inteiro.`,
      ip: (e) => `O campo deve ser um endereço IP válido.`,
      length: (e, n) => {
        var o = n[0]
        var r = n[1]
        return r ? `O tamanho do campo está entre ${o} e ${r}.` : `O tamanho do campo ${e} deve ser ${o}.`
      },
      max: (e, n) => `O campo não deve ter mais que ${n[0]} caracteres.`,
      max_value: (e, n) => `O campo precisa ser ${n[0]} ou menor.`,
      mimes: (e) => `O campo deve ser um tipo de arquivo válido.`,
      min: (e, n) => `O campo deve conter pelo menos ${n[0]} caracteres.`,
      min_value: (e, n) => `O campo precisa ser ${n[0]} ou maior.`,
      not_in: (e) => `O campo deve ser um valor válido.`,
      numeric: (e) => `O campo deve conter apenas números`,
      regex: (e) => `O campo possui um formato inválido.`,
      required: (field) => `O campo é obrigatório.`,
      url: (e) => `O campo ${e} não é uma URL válida.`
    }
  }
}

export default dictionary
